import endPoint from "./../../libs/endPoint/avaliacaoinstitucional/QuestionariosRoutes.js";
import ApiServices from "@/services/uteis/ApiServices.js";
class QuestionariosServices {
  constructor() {
    this.endPoint = endPoint;
  }
  async clonarQuestionario(params = {}) {
    try {
      const url = this.endPoint.cloanar;
      const { data } = await ApiServices.post(url, params);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }
} // fim classe
export default new QuestionariosServices();
